module.exports = __webpack_public_path__ + "img/1.bbbdf30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/1.png
// module id = PKR3
// module chunks = 1